<template>
    <div
        class="app-multi-select"
        :class="{ 'has-error': error && error.length }"
    >
        <label v-if="label" :id="label">{{ label }}</label>

        <div class="app-select-wrap" v-click-outside="() => (open = false)">
            <div
                class="start-icon"
                v-if="startIcon"
                v-html="$icon(startIcon)"
            ></div>

            <div
                @click="toggleOptions"
                class="select-dropdown"
                v-html="eventFieldsHtml"
            ></div>

            <div class="icon" v-if="icon" v-html="$icon(icon)"></div>
            <div class="loader" v-if="loading" v-html="$icon('loader')"></div>

            <transition name="fade">
                <div v-if="open" class="select-dropdown-options">
                    <div
                        class="dropdown-option"
                        @click="toggleOption(option)"
                        :class="{ selected: isSelected(option) }"
                        v-for="(option, idx) in options"
                        :key="idx"
                        v-html="$trans(`event.fields.field_${option}`)"
                    ></div>
                </div>
            </transition>
        </div>

        <p class="message" v-if="message">{{ message }}</p>
        <p class="error" v-if="error">{{ error }}</p>
    </div>
</template>

<script>
export default {
    name: "app-multi-select",

    emits: ["update:modelValue", "focus", "blur", "change"],

    props: {
        options: {
            type: Array,
            default: () => []
        },
        modelValue: [String, Array],
        icon: [String, Boolean],
        startIcon: [String, Boolean],
        label: String,
        id: String,
        value: [String],
        placeholder: String,
        message: String,
        error: String,
        autofocus: Boolean,
        loading: false,
        disabled: false
    },

    data() {
        return {
            newValue: this.modelValue,
            focused: false,
            open: false
        };
    },

    watch: {
        modelValue() {
            this.newValue = this.modelValue;
        }
    },

    methods: {
        onInput() {
            this.$emit("update:modelValue", this.newValue);
            this.$emit("change", this.newValue);
        },

        toggleOption(option) {
            if (
                option === "first_name" ||
                option === "last_name" ||
                option === "email" ||
                option === "tel"
            ) {
                return;
            }

            if (this.isSelected(option)) {
                this.newValue.splice(this.newValue.indexOf(option), 1);
            } else {
                this.newValue.push(option);
            }

            this.onInput();
        },

        isSelected(option) {
            if (
                option === "first_name" ||
                option === "last_name" ||
                option === "email" ||
                option === "tel"
            ) {
                return true;
            }

            return this.modelValue.includes(option);
        },

        toggleOptions() {
            this.open = !this.open;

            if (this.open) {
                this.$emit("focus");
            }
        }
    },

    computed: {
        filled() {
            return this.newValue || this.focused;
        },

        eventFieldsHtml() {
            if (this.placeholder) {
                return this.placeholder;
            }

            const fields = [...this.modelValue];

            return fields
                .map(field => this.$trans(`event.fields.${field}`))
                .join(", ");
        }
    }
};
</script>

<style lang="scss" scoped>
.app-multi-select {
    .loader {
        ::v-deep svg {
            stroke: black;
        }
    }
}
</style>
